
import createHeaders from "@utils/createHeaders";

const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Kode Wilayah', value: 'nama_wilayah', width: '20%'},
  { text: 'Digit 2-3', value: 'kode_wilayah', width: '70%'},
  { text: 'Action', value: 'action',width: '10%'},
]);

export default headers;

